<style lang="scss" scoped>
.product-category {
    .loading {
        display: flex;
        flex: 1;
        text-align: center;
        justify-content: center;
        align-items: center;
        min-height: 468px;
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>

<template>
    <div class="product-category">
        <transition name="component-fade" mode="out-in">
            <div v-if="ready" key="ready">
                <product-rows :products="sortedProducts">
                    <slot></slot>
                </product-rows>
            </div>
            <div key="loading" v-else class="loading">
                <spinner></spinner>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Ui.ProductCategoryOverview',

    props: {
        categoryId: {
            type: Number,
            required: true,
        },
        categoryTotal: {
            type: Number,
            required: true,
        },
        sortedIds: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            ready: false,
            products: [],
        };
    },

    mounted() {
        const self = this;

        var promise = this.getProducts(this.categoryId);

        promise.then(
            function () {
                self.ready = true;
            },
            function (error) {
                console.log(error);
            },
        );
    },

    methods: {
        getProducts(categoryId) {
            const self = this;
            return new Promise(function (resolve, reject) {
                axios
                    .get(`/api/products/${categoryId}?total=${self.categoryTotal}`)
                    .then(function (response) {
                        self.products = response.data;
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        },
    },

    computed: {
        sortedProducts() {
            //sort this.products in the order of the sortedIds
            return this.products.sort((a, b) => {
                return this.sortedIds.indexOf(a.id) - this.sortedIds.indexOf(b.id);
            });
        },
    },
};
</script>
